import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { autocompleteAirports } from "../../api";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { TabInfo } from "../../types";
import { selectConfig } from "../config/ConfigSlice";
import { changeDestinationAirport, changeInitialDestinationAirport, changeInitialOriginAirport, changeOriginAirport, changeStartAirport, FlightResultContent, resetFlightsForm, resetFlightsResults, selectChosenFlightsResults } from "./searchFlightsSlice";

function FormTopTabs() { 
  const { components, mapper, app } = useSelector(selectConfig);
  const dispatch = useAppDispatch();
  const originAirport = useAppSelector(
    (state) => state.searchFlights.form.originAirport
  );
  const destinationAirport = useAppSelector(
    (state) => state.searchFlights.form.destinationAirport
  );

  const flightResult: FlightResultContent = useAppSelector(
    selectChosenFlightsResults
  );
  const [curTab, setCurTab] = useState("");
  const [results, setAirports] = useState([]);
  useEffect(()=>{
    let airport: TabInfo;
    const promises = components.FormTopTabs.map(
      (airport) => {
        return autocompleteAirports(app, mapper, airport.code);
      }
    );
    Promise.all(promises).then((result) => {
      setAirports(result);
    });
    if(originAirport) {
      airport = components.FormTopTabs.find((airport) => airport.code === originAirport.port.code)
    }
    if(destinationAirport) {
      airport = components.FormTopTabs.find((airport) => airport.code === destinationAirport.port.code)
    }
    if(airport) setCurTab(airport.code);
    
  }, [components.FormTopTabs, originAirport, destinationAirport, app, mapper]);

  const setTab = (tab) => {
    if (flightResult && !flightResult.error && flightResult.flights) {
      dispatch(resetFlightsResults("flights"));
      dispatch(resetFlightsForm());
    } 
    dispatch(changeStartAirport(tab));
    const airports = results.find((ariport) => ariport.pattern === tab);
    const airport = airports.results.find(
      (airport) => airport.port.code === tab
    );
    if (airport) {
      airport.readOnly = true;
      if (mapper.lockOrigin) {
        dispatch(changeOriginAirport(airport));
        dispatch(changeDestinationAirport(null));
        dispatch(changeInitialOriginAirport(airport));
      }
      if (mapper.lockDestination) {
        dispatch(changeOriginAirport(null));
        dispatch(changeDestinationAirport(airport));
        dispatch(changeInitialDestinationAirport(airport));
      }
    }
    
    setCurTab(tab);
  }
  if (components.FormTopTabs.length > 0) {
    return (
      <div className="form-top-tabs" role="tablist">
        {components.FormTopTabs.map((tab, i)=>{
          return <div 
          className={(curTab === tab.code ? "" : "form-top-tab-unseld ")+ "form-top-tab"} 
          key={i}
          onClick={()=>setTab(tab.code)} 
          role="tab">
            {tab.label}
          </div>
        })}
      </div>
    );
  } else {
    return null;
  }
}

export default FormTopTabs;

